import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Overview from "@/pages/Overview";
import Sales from "@/pages/Sales";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Inventory from "@/pages/Inventory";
import Transactions from "@/pages/Transactions";
import Returns from "@/pages/Returns";
import Profitability from "@/pages/Profitability";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import Marketing from "@/pages/Marketing";
import StockRecon from "@/pages/StockRecon";
import { ForgotPassword, ForgotEmail, ResetPassword } from "@/pages/AccountFlows";

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/forgot-email" element={<ForgotEmail />} />
                        <Route path="/reset-password" element={<ResetPassword mode="reset" />} />
                        <Route path="/set-password" element={<ResetPassword mode="setup" />} />
                        <Route
                            element={
                                <ProtectedRoute>
                                    <Layout />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/" element={<Overview />} />
                            <Route path="/sales" element={<Sales />} />
                            <Route path="/products" element={<Products />} />
                            <Route path="/products/:sku" element={<ProductDetail />} />
                            <Route path="/inventory" element={<Inventory />} />
                            <Route path="/transactions" element={<Transactions />} />
                            <Route path="/returns" element={<Returns />} />
                            <Route path="/profitability" element={<Profitability />} />
                            <Route path="/marketing" element={<Marketing />} />
                            <Route path="/stock-recon" element={<StockRecon />} />
                            <Route path="/settings" element={<Settings />} />
                            <Route path="/users" element={<Users />} />
                        </Route>
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}
